/**
 * WhatsApp Widget — hyggepetfood.com / Flux Pawn OS 2.0
 * File    : assets/whatsapp-widget.js
 * Version : 1.3.1 — production ready (Fixed Routing & A11y)
 */
(function () {
  'use strict';

  var LS_KEY    = 'hg_wa_popup_closed';
  var LS_TTL_MS = 86400000;

  var root = document.getElementById('hg-wa-root');
  if (!root) return;

  var fab          = root.querySelector('.hg-wa-fab');
  var tab          = root.querySelector('.hg-wa-tab');
  var overlay      = root.querySelector('.hg-wa-popup-overlay');
  var popupClose   = overlay && overlay.querySelector('.hg-wa-popup-close');
  var popupCta     = overlay && overlay.querySelector('.hg-wa-popup-cta');

  var usePopup  = root.dataset.popup === 'true';
  var autoPopup = root.dataset.auto  === 'true';
  var autoDelay = parseInt(root.dataset.delay || '5000', 10);

  var isOpen = false;

  function emit(name, detail) {
    try {
      document.dispatchEvent(new CustomEvent(name, { detail: detail, bubbles: true }));
    } catch (_) {}
  }

  function lsGet(key) {
    try {
      var raw = localStorage.getItem(key);
      if (!raw) return null;
      var obj = JSON.parse(raw);
      if (Date.now() > obj.exp) { localStorage.removeItem(key); return null; }
      return obj.value;
    } catch (_) { return null; }
  }

  function lsSet(key, value, ttl) {
    try {
      localStorage.setItem(key, JSON.stringify({ value: value, exp: Date.now() + ttl }));
    } catch (_) {}
  }

  function buildUrl(phone, message) {
    var clean = (phone || '').replace(/\D/g, '');
    var url = 'https://wa.me/' + clean;
    if (message) url += '?text=' + message;
    return url;
  }

  function openWhatsApp(el) {
    var phone   = el.dataset.phone   || root.dataset.phone   || '';
    var message = el.dataset.message || root.dataset.message || '';
    var url     = buildUrl(phone, message);
    emit('hg:wa:open', { phone: phone, url: url, source: el.dataset.source || 'widget' });
    window.open(url, '_blank', 'noopener,noreferrer');
  }

  function getFocusable() {
    if (!overlay) return [];
    return Array.from(
      overlay.querySelectorAll('a, button, [tabindex]:not([tabindex="-1"])')
    ).filter(function (el) { return !el.disabled; });
  }

  function trapFocus(e) {
    if (!isOpen) return;
    var focusable = getFocusable();
    if (!focusable.length) return;
    var first = focusable[0];
    var last  = focusable[focusable.length - 1];
    if (e.key === 'Tab') {
      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault(); last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault(); first.focus();
      }
    }
  }

  function setExpanded(value) {
    [fab, tab].forEach(function (el) {
      if (el) el.setAttribute('aria-expanded', value ? 'true' : 'false');
    });
  }

  function openPopup() {
    if (!overlay || isOpen) return;
    isOpen = true;
    overlay.classList.add('hg-wa-open');
    overlay.setAttribute('aria-hidden', 'false');
    setExpanded(true);
    
    setTimeout(function () {
      if (!isOpen) return;
      var focusable = getFocusable();
      if (focusable.length) focusable[0].focus();
    }, 220);
    
    emit('hg:wa:popup', { action: 'open' });
  }

  function closePopup(remember) {
    if (!overlay || !isOpen) return;
    isOpen = false;
    overlay.classList.remove('hg-wa-open');
    overlay.setAttribute('aria-hidden', 'true');
    setExpanded(false);
    if (remember) lsSet(LS_KEY, true, LS_TTL_MS);
    emit('hg:wa:popup', { action: 'close' });
  }

  function togglePopup() {
    isOpen ? closePopup(false) : openPopup();
  }

  function returnFocus() {
    if (document.activeElement === document.body || !document.activeElement) {
      if (tab && tab.offsetParent !== null) { tab.focus(); }
      else if (fab) { fab.focus(); }
    }
  }

  if (fab) {
    fab.addEventListener('click', function (e) {
      e.preventDefault();
      usePopup ? togglePopup() : openWhatsApp(this);
    });
  }

  if (tab) {
    tab.addEventListener('click', function (e) {
      e.preventDefault();
      usePopup ? togglePopup() : openWhatsApp(this);
    });
  }

  if (popupClose) {
    popupClose.addEventListener('click', function () {
      closePopup(true);
      returnFocus();
    });
  }

  if (popupCta) {
    popupCta.addEventListener('click', function (e) {
      e.preventDefault();
      openWhatsApp(this);
      closePopup(false);
    });
  }

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && isOpen) {
      closePopup(false);
      returnFocus();
    }
    trapFocus(e);
  });

  if (overlay) {
    overlay.addEventListener('click', function (e) {
      if (e.target === overlay) closePopup(true);
    });
  }

  if (autoPopup && usePopup && overlay) {
    if (!lsGet(LS_KEY)) {
      setTimeout(openPopup, autoDelay);
    }
  }

})();